import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

//import { particularservice } from '../services/particulars/provider.service';
import { PlanService } from '../services/plans/plan.service';

import { Plan } from '../classes/plan';


@Component({
  selector: 'particulars',
  templateUrl: './particulars.component.html',
  styleUrls: ['./particulars.component.css']
})
export class ParticularsComponent implements OnInit {

  particulars: any[]
  plans: Plan[];
  newParticular: any={
    name:"",
    email:"",
    gender:"",
    phone:"",
    birthday:Date
  }//Provider = new Provider();

  constructor(//protected particularservice: particularservice,
    protected planService: PlanService,
    protected router: Router) {
  }

  protected getDetailUrl(): string {
    return '/particulars/'
  };

  ngOnInit() {
    this.loadAppsInfo();
  }

  loadAppsInfo() {
    /*this.particularservice.get().then(particulars => {
      this.particulars = particulars;
    });*/
    this.planService.get({}).then(plans => {
      this.plans = plans
    })
  }

  add() {
    /*this.particularservice.create(this.newProvider)
      .then(_ => {
        this.loadAppsInfo();
        this.newProvider.name = "";
        this.newProvider.serviceObjectName = "";
        this.newProvider.auth0ConnectionName = "";
      })
      .catch(error => {
        alert("There was an error creating app. Server message: " + error.message);
      });*/
  }

  onNotify(message: string) {
    if (message == 'deleted')
      this.loadAppsInfo();
  }

  viewDetail(particular) {
    this.router.navigate([this.getDetailUrl() + particular.id]);
  }

}



// WEBPACK FOOTER //
// ./src/app/particular/particulars.component.ts